<template>
    <div :class="[colorClass, 'footer-marquee-wrapper py-4 md:py-10.75']">
        <Swiper v-bind="swiperProps" class="footer-marquee">
            <SwiperSlide v-for="idx in 3" :key="`footer-marquee-${idx}`">
                <div class="flex gap-x-6.5">
                    <FooterMarqueeBanner class="shrink-0 w-auto h-8  md:w-246.5 md:h-17.5" />
                    <FooterMarqueeLogo class="shrink-0 w-auto h-8 md:w-99.75 md:h-17.5" />
                </div>
            </SwiperSlide>
        </Swiper>
    </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import FooterMarqueeBanner from '../../../images/footer-marquee/banner.svg';
import FooterMarqueeLogo from '../../../images/footer-marquee/logo.svg';
import { computed } from 'vue';
import { Autoplay } from 'swiper/modules';

const props = defineProps({ color: { type: String, default: 'gold' } });

const colorClass = computed(() => {
    if (props.color == 'gold') {
        return 'bg-gold text-gold';
    } else {
        return 'bg-gold text-gold';
    }
});

const swiperProps = {
    slidesPerView: 'auto',
    spaceBetween: 26,
    loop: true,
    speed: 16000,
    allowTouchMove: false,
    modules: [Autoplay],
    autoplay: {
        delay: 1,
        disableOnInteraction: false,
    },
};
</script>

<style>
.footer-marquee .swiper-wrapper {
    transition-timing-function: linear;
}

.footer-marquee .swiper-slide {
    width: fit-content;
}
</style>
